import { Suspense } from 'react'
import { ErrorBoundary } from 'react-error-boundary'
import { Outlet } from 'react-router'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import QS from 'query-string'
import { QueryParamProvider } from 'use-query-params'

import { LoadingScreen } from '@shared/components/src/Loader'
import ReactRouterAdapter from '@shared/components/src/ReactRouterAdapter'
import { reportError } from '@shared/providers/src/HoneybadgerProvider'
import QueryClientProvider from '@shared/providers/src/QueryClientProvider'
import { BuildEnv } from '@shared/utils'

import AxiosErrorHandler from '@providers/AxiosErrorHandler'
import LanguageProvider from '@providers/LanguageProvider'
import ThemeProvider from '@providers/ThemeProvider'
import WhiteLabeling from '@providers/WhiteLabeling'
import GoogleTranslate from '@components/GoogleTranslate'
import LeavePromptProvider from '@components/LeavePrompt'

import Error from '../Misc/Error'

export default function Root() {
  return (
    <QueryParamProvider adapter={ReactRouterAdapter} options={{ searchStringToObject: QS.parse, objectToSearchString: QS.stringify }}>
      <LanguageProvider>
        <ThemeProvider>
          <AxiosErrorHandler>
            <QueryClientProvider>
              <ErrorBoundary FallbackComponent={Error} onError={reportError}>
                <Suspense fallback={<LoadingScreen />}>
                  <WhiteLabeling>
                    <LeavePromptProvider>
                      <Outlet />
                    </LeavePromptProvider>
                    {window.isNativeApp !== true && <GoogleTranslate />}
                    {/*{import.meta.env.VITE_BUILD_ENV !== BuildEnv.Production && window.isNativeApp !== true && (*/}
                    {/*  <ReactQueryDevtools initialIsOpen={false} />*/}
                    {/*)}*/}
                  </WhiteLabeling>
                </Suspense>
              </ErrorBoundary>
            </QueryClientProvider>
          </AxiosErrorHandler>
        </ThemeProvider>
      </LanguageProvider>
    </QueryParamProvider>
  )
}
